import { render, staticRenderFns } from "./DescuentosLista.vue?vue&type=template&id=efb075c6&scoped=true"
import script from "./DescuentosLista.vue?vue&type=script&lang=js"
export * from "./DescuentosLista.vue?vue&type=script&lang=js"
import style0 from "./DescuentosLista.vue?vue&type=style&index=0&id=efb075c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb075c6",
  null
  
)

export default component.exports